import { X } from 'lucide-react';
import { observer } from 'mobx-react';
import { translation, TranslationsContext } from '../../../Translations';
import ToastStore from '../Store';

interface Props {
  store: ToastStore;
}

const dismiss = (store: ToastStore) => () => store.dismiss();

function DismissButton({ store }: Props) {
  return (
    <TranslationsContext.Consumer>
      {(ts) => (
        <button
          type="button"
          onClick={dismiss(store)}
          className="rounded-md p-1 focus:outline-none focus:ring-2 focus:ring-ring"
          aria-label={translation('Dismiss')(ts)}
          data-intercom-target="toast-dismiss-button"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
    </TranslationsContext.Consumer>
  );
}

export default observer(DismissButton);
